var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.51,
    height: 22.502,
    viewBox: "0 0 23.51 22.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_267",
    "data-name": "Grupo 267",
    transform: "translate(-1803.52 -192.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    transform: "translate(1803.52 203.552) rotate(-51)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.269,0a7.344,7.344,0,0,1,7.31,7.319A7.245,7.245,0,0,1,7.31,14.6,7.344,7.344,0,0,1,0,7.278,7.245,7.245,0,0,1,7.269,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.248617172241211 2.999999046325684 C 6.110257148742676 2.999999046325684 5.04212760925293 3.442449569702148 4.240967750549316 4.245849609375 C 3.437527656555176 5.051539421081543 2.996817588806152 6.125438690185547 3.000017166137695 7.26970911026001 C 3.006677627563477 9.649158477783203 4.94401741027832 11.59038925170898 7.318687438964844 11.59703922271729 L 7.331087589263916 11.59705924987793 C 8.469437599182129 11.59705924987793 9.537567138671875 11.15460968017578 10.33871746063232 10.35121917724609 C 11.14216709136963 9.54551887512207 11.58287715911865 8.47161865234375 11.57967758178711 7.327339172363281 C 11.57301712036133 4.947898864746094 9.635686874389648 3.006669044494629 7.261017322540283 3.000019073486328 L 7.248617172241211 2.999999046325684 M 7.248615264892578 0 C 7.255736827850342 0 7.262310981750488 9.5367431640625e-06 7.269437313079834 2.956390380859375e-05 C 11.29548740386963 0.01130962371826172 14.56838703155518 3.28809928894043 14.57966709136963 7.318939208984375 C 14.59093761444092 11.34978866577148 11.33662033081055 14.60829925537109 7.310267448425293 14.5970287322998 C 3.284207344055176 14.58574867248535 0.01130771636962891 11.30895900726318 2.765655517578125e-05 7.278109073638916 C -0.01122283935546875 3.254393577575684 3.232415199279785 0 7.248615264892578 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M0,0,2.3.006,2.334,11.53l-2.3-.006Z",
    transform: "translate(1816.6 207.468) rotate(-51)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0f4c92168bd3fa34ae8850d1bb79489a.svg";
export { ForwardRef as ReactComponent };